import * as Yup from 'yup';
import i18n from '../../utils/i18n';
import { INPUT_PARAM_CONSTRAINTS } from './constants';

const validationSchema = Yup.object().shape({
	vinMin: Yup.number()
		.typeError(i18n.t('errors:vinMinNumber'))
		.required(i18n.t('errors:vinMinRequired'))
		.test(
			'vinMinInRange',
			i18n.t('errors:vinMinInRange'),
			value =>
				parseFloat(value) >= INPUT_PARAM_CONSTRAINTS.VIN_MIN && parseFloat(value) <= INPUT_PARAM_CONSTRAINTS.VIN_MAX
		)
		.max(Yup.ref('vinMax'), i18n.t('errors:vinMinLoOrEqToVinMax')),
	vinMax: Yup.number()
		.typeError(i18n.t('errors:vinMaxNumber'))
		.required(i18n.t('errors:vinMaxRequired'))
		.test(
			'vinMaxInRange',
			i18n.t('errors:vinMaxInRange'),
			value =>
				parseFloat(value) >= INPUT_PARAM_CONSTRAINTS.VIN_MIN && parseFloat(value) <= INPUT_PARAM_CONSTRAINTS.VIN_MAX
		)
		.min(Yup.ref('vinMin'), i18n.t('errors:vinMaxEqOrGrThanVinMin')),
	vout: Yup.number()
		.typeError(i18n.t('errors:voutNumber'))
		.required(i18n.t('errors:voutRequired'))
		.test(
			'voutInRange',
			i18n.t('errors:voutInRange'),
			value =>
				parseFloat(value) > INPUT_PARAM_CONSTRAINTS.VOUT_MIN && parseFloat(value) <= INPUT_PARAM_CONSTRAINTS.VOUT_MAX
		),
	iout: Yup.number()
		.typeError(i18n.t('errors:ioutNumber'))
		.required(i18n.t('errors:ioutRequired'))
		.test(
			'ioutInRange',
			i18n.t('errors:ioutInRange'),
			value =>
				parseFloat(value) > INPUT_PARAM_CONSTRAINTS.IOUT_MIN && parseFloat(value) <= INPUT_PARAM_CONSTRAINTS.IOUT_MAX
		),
	ambientTemperature: Yup.number()
		.typeError(i18n.t('errors:ambientTemperatureNumber'))
		.required(i18n.t('errors:ambientTemperatureRequired'))
		.test(
			'ambientTemperatureInRange',
			i18n.t('errors:ambientTemperatureInRange'),
			value =>
				parseFloat(value) >= INPUT_PARAM_CONSTRAINTS.AMB_TEMP_MIN &&
				parseFloat(value) <= INPUT_PARAM_CONSTRAINTS.AMB_TEMP_MAX
		),
	vinNom: Yup.number()
		.typeError(i18n.t('errors:vinNomNumber'))
		.min(Yup.ref('vinMin'), i18n.t('errors:vinNomBetweenVinMinAndVinMax'))
		.max(Yup.ref('vinMax'), i18n.t('errors:vinNomBetweenVinMinAndVinMax'))
});

export default validationSchema;
